
import React, { Component, Fragment } from "react";
import _ from 'lodash';
import styled from 'styled-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {PrimaryButton, SecondaryButton} from 'components/Global/Buttons'
import {
    TwoDecimalPercentFormat,
    DollarAndCentFormat,
    FloatFormat,
  } from 'components/Notifications/FormattedInputs';
import ratingTriggers from "constants/ratingTriggers";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding-right: 60px;
    color: #666;
    min-width: 700px;
  }
`;

const StyledTextField = styled(TextField)`
  max-width:130px;
`;

const DEFAULT_RATING_ID = '9ad1ec64-7d75-11e9-9c8e-0242ac140002'; // A+/A1
/*
handleClose is whenever its closed with X
handleAccept is only when they click OK. 
secondaryContent comes after message. Can be more text or another component
*/
class WatchHedgeStubModal extends Component {

    state = {
        notional : this.props.defaultNotional || null,
        hedgeType: {value:"Cap"},
        strike: null,
        term: null,
        spread: null,
        creditCharge: null,
        ratingsTriggerId: DEFAULT_RATING_ID,
    }

    renderRatingsMenuItems = () => {
        const out = [];
        ratingTriggers.list.forEach(item => {
            out.push(<MenuItem value={item.value}>{item.name}</MenuItem>)
        });
        return out;
    }

    componentDidUpdate (prevProps) {
        const props = this.props;
        if(prevProps.hedge && !props.hedge){
            this.setState({
                notional: this.props.defaultNotional || null,
                hedgeType: {value: "Cap"},
                strike: null,
                term: null,
                spread: null,
                creditCharge: null,
                ratingsTriggerId: DEFAULT_RATING_ID,
            })
        }
        if(!prevProps.hedge && props.hedge || ((prevProps.hedge && props.hedge) && prevProps.hedge.id != props.hedge.id)){
            this.setState({
                notional: props.hedge.notional,
                hedgeType: props.hedge.hedgeType,
                strike: props.hedge.strike,
                term: props.hedge.term,
                spread: props.hedge.spread,
                creditCharge: props.hedge.creditCharge,
                ratingsTriggerId: props.hedge.ratingsTriggerId,
            })
        }
    }
    
   render() {
    const {modalOpen, handleClose, handleAccept, hedge, defaultNotional} = this.props;
    let isSwap = this.state.hedgeType && this.state.hedgeType.value.toLowerCase() === "swap";
    let isCap = this.state.hedgeType && this.state.hedgeType.value.toLowerCase() === "cap";
    return (
      <Dialog maxWidth={"md"} open={modalOpen} onClose={handleClose} id={"InfoDialog"}>
        <DialogTitle>Hedge</DialogTitle>
        <StyledDialogIconButton onClick={handleClose}>
            <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>
        <StyledDialogContent>
            <FormControl>
            <InputLabel style={{}} htmlFor="hedgeType">Hedge Type</InputLabel>
            <Select
                inputProps={{
                    name: 'Hedge Type',
                    id: 'hedgeType',
                }}
                style = {{backgroundColor: "white", minWidth: "100px"}}
                value = {this.state.hedgeType.value}
                onChange = {event => {
                    this.setState({hedgeType: {value: event.target.value}});
                }}
                
            >
                <MenuItem value={"Cap"}>Cap</MenuItem>
                <MenuItem value={"Swap"}>Swap</MenuItem>
            </Select>
            </FormControl>
            <br/>
            <br/>
            {renderInput({
                type: "money",
                internalLabel: "Notional",
                value: this.state.notional,
                onChange: (event) => {this.setState({notional: event.target.value})},
                style: {marginRight: "20px"}
            })}

            {isCap &&
                <>
                {renderInput({
                    type: "percent",
                    internalLabel: "Strike",
                    value: this.state.strike,
                    onChange: (event) => {this.setState({strike: parseFloat(event.target.value)})},
                    style: {marginRight: "20px"}
                })}
                </>
            }
            
            {isSwap && 
                <>
                {renderInput({
                    type: "percent",
                    internalLabel: "Spread",
                    value: this.state.spread,
                    onChange: (event) => {this.setState({spread: parseFloat(event.target.value)})},
                    style: {marginRight: "20px"}
                })}
                </>
            }

            {renderInput({
                type: "integer",
                internalLabel: "Term (Months)",
                value: this.state.term,
                onChange: (event) => {this.setState({term: parseFloat(event.target.value)})},
                style: {marginRight: "20px"}
            })}
            <br/>
            <br/>
            {isSwap && 
                <>
                {renderInput({
                    type: "integer",
                    internalLabel: "Credit Charge (bps)",
                    value: this.state.creditCharge,
                    onChange: (event) => {this.setState({creditCharge: parseFloat(event.target.value)})}
                })}
                </>
            }
            {isCap && 
                <FormControl>
                    <InputLabel style={{}} htmlFor="ratingsTriggerId">Rating</InputLabel>
                    <Select
                        inputProps={{
                            name: 'Ratings',
                            id: 'ratingsTriggerId',
                        }}
                        style = {{backgroundColor: "white", width: "200px"}}
                        value = {this.state.ratingsTriggerId}
                        onChange = {event => {
                            this.setState({ratingsTriggerId: event.target.value});
                        }}
                    
                    >
                    {this.renderRatingsMenuItems()}
                    </Select> 
                </FormControl>
            }
        </StyledDialogContent>
        <DialogActions>
            <SecondaryButton id="dialogCancel" onClick={handleClose}>{"Cancel"}</SecondaryButton>
            <PrimaryButton id="dialogOK" onClick={()=>handleAccept(this.state)}>{"Save"}</PrimaryButton>
        </DialogActions>
      </Dialog>);
  }
  

}

const renderInput = ({type, defaultValue, onChange, onBlur, style, internalLabel, value}) => {
    let inputProps = {
    style:{
        textAlign: "center", 
        transition: '0.3s',
        }
    };
    switch(type){
        case 'money':
            inputProps.inputComponent = DollarAndCentFormat;
            break;   
        case 'percent':
            inputProps.inputComponent = TwoDecimalPercentFormat;
            break;
        case 'integer':
            inputProps.inputComponent = FloatFormat;
        default:
            break;
    }
    return (
        <StyledTextField 
            defaultValue = {defaultValue}
            InputProps = {inputProps}
            onChange = {onChange}
            onBlur = {onBlur}
            label = {internalLabel}
            style={style}
            value = {value}
        />
    )
}

  export default WatchHedgeStubModal